import { render, staticRenderFns } from "./VendorListingSection.vue?vue&type=template&id=0a4eeb0c&scoped=true&"
import script from "./VendorListingSection.vue?vue&type=script&lang=js&"
export * from "./VendorListingSection.vue?vue&type=script&lang=js&"
import style0 from "./VendorListingSection.vue?vue&type=style&index=0&id=0a4eeb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4eeb0c",
  null
  
)

export default component.exports